import { APP_ID, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BidiModule, Directionality } from '@angular/cdk/bidi';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { DirectionService } from './services/direction.service';
import { ToastrModule } from 'ngx-toastr';
import { ToastComponent } from './shared/toast/toast.component';
import { ApiInterceptor } from './shared/api-interceptor';
import { AppComponent } from './app.component';
import { LandingComponent } from './landing/landing.component';
import { WaiterComponent } from './shared/waiter/waiter.component';
import { BillComponent } from './bill/bill.component';
import { SentryModule } from './shared/sentry';
import { CartComponent } from './cart/cart.component';
import { RecommendationsComponent } from './cart/recommendations/recommendations.component';
import { ChargeToMyRoomComponent } from './bill/charge-to-my-room/charge-to-my-room.component';
import { SplashScreenComponent } from './splash-screen/splash-screen.component';
import { AppRoutingModule } from './app-routing.module';
import { MenuModule } from './menu/menu.module';
import { SharedModule } from './shared/shared.module';
import { OrderConfirmationComponent } from './order-confirmation/order-confirmation.component';
import { BillPaidComponent } from './bill-paid/bill-paid.component';
import { LanguageSelectionComponent } from './language-selection/language-selection.component';
import { EzetapComponent } from './self-checkout/ezetap/ezetap.component';
import { AlertDialogComponent } from './shared/alert-dialog/alert-dialog.component';
import { TotalProcessingComponent } from './total-processing/total-processing.component';
import { PayAtTableModule } from './pay-at-table/pay-at-table-module';
import { PayNowAtTableComponent } from './cart/pay-now-at-table/pay-now-at-table.component';
import { PromotionComponent } from './shared/promotion/promotion.component';
import { AdyenComponent } from './self-checkout/adyen/adyen.component';
import { GeideaComponent } from './self-checkout/geidea/geidea.component';
import { CheckoutV2Component } from './self-checkout/checkout-v2/checkout-v2.component';
import { QRScanComponent } from './qrscan/qrscan.component';
import { OrderFormComponent } from './cart/order-form/order-form.component';
import { NgxMatInputTelComponent } from 'ngx-mat-input-tel';
import { CybersourceComponent } from './self-checkout/cybersource/cybersource.component';

@NgModule({
    declarations: [
        AppComponent,
        LandingComponent,
        CartComponent,
        RecommendationsComponent,
        WaiterComponent,
        BillComponent,
        ChargeToMyRoomComponent,
        SplashScreenComponent,
        PayNowAtTableComponent,
        OrderConfirmationComponent,
        BillPaidComponent,
        LanguageSelectionComponent,
        EzetapComponent,
        AlertDialogComponent,
        TotalProcessingComponent,
        OrderFormComponent,
        AdyenComponent,
        GeideaComponent,
        CheckoutV2Component,
        QRScanComponent,
        CybersourceComponent,
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [CommonModule,
        BidiModule,
        BrowserAnimationsModule,
        SentryModule,
        MenuModule,
        SharedModule,
        AppRoutingModule,
        PayAtTableModule,
        PromotionComponent,
        NgxMatInputTelComponent,
        ToastrModule.forRoot({
            toastComponent: ToastComponent,
            positionClass: 'toast-top-center',
            newestOnTop: true,
            preventDuplicates: true,
        })], providers: [
            { provide: APP_ID, useValue: 'serverApp' },
            { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true },
            { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
            // Overrides the stock CDK Directionality at the root injector - see DirectionService.
            { provide: Directionality, useExisting: DirectionService },
            provideHttpClient(withInterceptorsFromDi()),
        ]
})
export class AppModule { }
